import React, { useState, useEffect } from "react";
import { Table, Input, Empty, Row, Col, Radio } from "antd";
import { EmployeeCompanyDto, EmployeeCompanyStore } from "src/stores/employees-store";
import { Link, RouteComponentProps, withRouter } from "react-router-dom";
import ContentTitle from 'src/core/ui/content-header';
import { withTranslation, WithTranslation } from "react-i18next";
import { IdentityProps, withIdentity } from 'src/core/services/authentication';
import { UserProfileProps, withUserProfile } from "../../../components/user-profile";
import { checkAuthAdminFi, checkAuthAdmin as isAdmin } from "../../../utils/CheckValidationbyUsers";

interface Props extends RouteComponentProps, WithTranslation, UserProfileProps {
}

const employeesStore = new EmployeeCompanyStore();

const CompanyUserList: React.FC<Props> = (props: Props) => {
    const [searchText, setSearchText] = useState("");
    const [dataSource, setDataSource] = useState<EmployeeCompanyDto[]>([]);
    const { t } = props;
    const handleNavigate = (path: string) => {
        props.history.push(path);
    };

    useEffect(() => {
        employeesStore.changeEployeeUrl();
    }, []);

    const load = async (searchValue: string) => {
        if (searchValue.trim() !== "") {
            const result: EmployeeCompanyDto[] = await employeesStore.getEmployeesCompanies(searchValue);
            setDataSource(result.map((item) => ({ ...item, key: item.id.toString() })));     
        } else {
            setDataSource([]); 
        }
    };

    useEffect(() => {
        load(searchText);
    }, [searchText]);

    const columns = [
        {
            title: <span>{t('Employee name')}</span>,
            dataIndex: "name",
            key: "name",
            width: '30%',
            render: (text: any, record: any) => (
                <Link to={`/time-tracking/admin/companies/${record.companyId}/employees/${record.id}`}>{text}</Link>
            )
        },
        {
            title: <span>{t('Employee Email')}</span>,
            dataIndex: "email",
            key: "email",
            width: '30%'
        },
        {
            title: <span>{t('Name Company')}</span>,
            dataIndex: "companyName",
            key: "companyName",
            width: '30%'
        }
    ];

    const checkAuthAdmin = () => {
        const roles = props.userProfile.roles;
        const allwedRoles = ["Administrator", "FIConsultant", "ClientAdmin"];

        return allwedRoles.some(role => roles.includes(role));
    };

    return (
        <>
            {checkAuthAdmin() && (
                <>
                    <Row>
                        <Col span={10}>
                            <ContentTitle title={t('Users By Company')} />
                        </Col>
                        <Col span={50} style={{ marginTop: 40 }}>
                            <Radio.Group style={{ float: 'right' }} value="company-user-list">
                                <Radio.Button value="company-users" onClick={() => handleNavigate(`/time-tracking/admin/`)}>{t('Companies Settings')}</Radio.Button>
                                {checkAuthAdminFi(props.userProfile) && <Radio.Button value="app-settings" onClick={() => handleNavigate(`/time-tracking/admin/appsettings/`)}>{t('Application Settings')}</Radio.Button>}
                            </Radio.Group>
                        </Col>
                    </Row>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                        <Input.Search
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            onSearch={(value) => load(value)} // Pasar el valor del campo de búsqueda a load
                            placeholder={t('Search Employees')}
                            style={{ maxWidth: '35%', marginBottom: 30, marginTop: 40 }}
                        />
                        {searchText.length > 0 ? (
                            <Table dataSource={dataSource} columns={columns} style={{ width: '90%', margin: '0 auto' }} />
                        ) : (
                            <Empty style={{ marginTop: 40 }} />
                        )}
                    </div>
                </>
            )}
        </>
    );
};

export default withUserProfile(withIdentity(withRouter(withTranslation()(CompanyUserList)) as any)) as any;